import React, { Component } from 'react'
import PropTypes from 'prop-types'

export class SlickImage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loaded: false
    }
  }

  static propTypes = {
    imageUrl: PropTypes.string.isRequired,
    ctrCls: PropTypes.string
  }

  static defaultProps = {
    ctrCls: ''
  }

  render() {
    const { loaded } = this.state;
    const { imageUrl, ctrCls } = this.props;
    return (
      <img  onLoad={this.onImageLoad.bind(this)} 
            src={imageUrl}
            className={`${ctrCls} slick-image ${loaded ? 'slick-image-loaded' : ''}` }/>
    )
  }

  onImageLoad(){
    const me = this;
    setTimeout(() => {
      me.setState({
        loaded: true
      })
    }, 250);
  }
}

export default SlickImage
